import {RootContainer} from '../../../core/root_container';
import {StockAreaAction} from '../../actions/stock_area_actions';
import {AddressChoiceModel, ItemJsEnv} from '../../models/item_js_env';
import {DeliveryCountdown} from './delivery_countdown';

export class StockAreaContainer extends RootContainer<AddressChoiceModel> {
  constructor(model: ItemJsEnv) {
    super();
    StockAreaAction.STOCK_DISPLAY_UPDATE_EVENT.on((newModel: AddressChoiceModel) => {
        this.updateElement(newModel);

        // 置換されたエリアで、addEventLisenerで実施している処理が呼び出されなかったので再度init
        StockAreaContainer.initStockAreaContainerListener(model);

        // 在庫表示エリアの文言更新を再度実行する
        DeliveryCountdown.updateElement(model.stockAreaJSOption.addressChoiceModel);
      }
    );
    // 初期化一度のみ実施する
    StockAreaContainer.initStockAreaContainerListener(model);
    StockAreaContainer.initModalEventListenerOutOfStockArea(model);
  };

  // エリア内の要素は置換された後に再度addEventListenerする
  private static initStockAreaContainerListener(model: ItemJsEnv) {
    // お届け先住所選択リストのプルダウンから選択
    document.getElementById('js-stock-delivery-address-pulldown')?.addEventListener('change',
      (element) => {
        const target = element.target as HTMLSelectElement
        StockAreaAction.deliveryDestinationAddressChoice(
          target.value,
        );
      });

    // 入荷案内メール登録リンク押下
    document.getElementById('js-stock-arrival-guide-mail-link')?.addEventListener('click',
      () => {
        StockAreaAction.stockArrivalGuideMailLink(
          model.stockAreaJSOption.addressChoiceModel.supplierId,
          model.stockAreaJSOption.addressChoiceModel.catalogItemCode,
          model.isLogin
        );
      });
  };

  // エリア以外の要素は一度のみaddEventListenerするように保証（しないとAPI呼び出すが爆発に増える）
  private static initModalEventListenerOutOfStockArea(model: ItemJsEnv) {
    // 在庫確認モーダル「この内容で確認」フォームのSubmit処理（エンターキーを考慮する必要ためClickイベントは足らない）
    document.getElementById('stock-quantity-confirm-form')?.addEventListener('submit',
      (e) => {
        e.preventDefault(); // 画面遷移防ぐ
        StockAreaAction.confirmStockQuantity(
          model.stockAreaJSOption.addressChoiceModel
        );
      });
  };

  static init(model: ItemJsEnv) {
    return new StockAreaContainer(model);
  };

  private updateElement(newModel: AddressChoiceModel) {
    const targetId = 'js-m-shippinginfo-area';
    const element = document.getElementById(targetId);
    // 読み込むhtmlにエラー発生した時には「共通エラー画面」を画面に反映しないように
    // includes(targetId)の正常に読み込んだかの検証が必要
    if (element == null || !newModel.resultHtmlStr.includes(targetId)) {
      return;
    }
    element.innerHTML = newModel.resultHtmlStr;
  };
}
